/**
 * Mapování materiálových řádků popupu ↔ draft JSON (parita KMP `MaterialCommitHelpers.selectedMaterialToDraftRow`).
 */
import type { ObjectPopupMaterialDraftRow } from './object-popup-local-draft.types';

export type PopupMaterialDraftSource =
  | {
      kind: 'component';
      sapCode: string;
      quantity?: number;
      label?: string;
      jednotka?: string | null;
      phaseCode?: string;
      addedByEmail?: string;
      materialUsageId?: string;
      sourceHistoryId?: string;
    }
  | {
      kind: 'bundle';
      bundleId: string;
      label: string;
      quantity?: number;
      lines?: { sapCode: string; quantity: number }[];
      jednotka?: string | null;
      phaseCode?: string;
      addedByEmail?: string;
      materialUsageId?: string;
      sourceHistoryId?: string;
    };

export function selectedMaterialToDraftRow(item: PopupMaterialDraftSource): ObjectPopupMaterialDraftRow {
  if (item.kind === 'bundle') {
    return {
      kind: 'bundle',
      bundleId: item.bundleId,
      bundleLabel: item.label,
      sapCode: item.bundleId,
      quantity: item.quantity ?? 0,
      label: item.label,
      jednotka: item.jednotka ?? null,
      phaseCode: item.phaseCode ?? null,
      addedByEmail: item.addedByEmail ?? null,
      materialUsageId: item.materialUsageId ?? null,
      sourceHistoryId: item.sourceHistoryId ?? null,
    };
  }
  return {
    kind: 'component',
    sapCode: item.sapCode,
    quantity: item.quantity ?? 0,
    label: item.label ?? null,
    jednotka: item.jednotka ?? null,
    phaseCode: item.phaseCode ?? null,
    addedByEmail: item.addedByEmail ?? null,
    materialUsageId: item.materialUsageId ?? null,
    sourceHistoryId: item.sourceHistoryId ?? null,
  };
}

export function draftRowToSelectedMaterial(row: ObjectPopupMaterialDraftRow): PopupMaterialDraftSource {
  if (row.kind === 'bundle') {
    const bundleId = (row.bundleId ?? row.sapCode ?? '').trim();
    return {
      kind: 'bundle',
      bundleId,
      label: row.bundleLabel ?? row.label ?? bundleId,
      quantity: row.quantity ?? 0,
      lines: [],
      jednotka: row.jednotka ?? null,
      phaseCode: row.phaseCode ?? undefined,
      addedByEmail: row.addedByEmail ?? undefined,
      materialUsageId: row.materialUsageId ?? undefined,
      sourceHistoryId: row.sourceHistoryId ?? undefined,
    };
  }
  return {
    kind: 'component',
    sapCode: (row.sapCode ?? '').trim(),
    quantity: row.quantity ?? 0,
    label: row.label ?? undefined,
    jednotka: row.jednotka ?? null,
    phaseCode: row.phaseCode ?? undefined,
    addedByEmail: row.addedByEmail ?? undefined,
    materialUsageId: row.materialUsageId ?? undefined,
    sourceHistoryId: row.sourceHistoryId ?? undefined,
  };
}
